import React, { useEffect, useState } from 'react'
import './Webgate.css'
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import { addPresentation, getLogs, getLogsAndParams, getPresentation } from '../../services/http';
import { toast } from 'react-toastify';
import MarkdownEditor from '@uiw/react-markdown-editor';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import Loader from '../../components/Loader/Loader';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
// import style manually
import 'react-markdown-editor-lite/lib/index.css';


const Webgate = () => {


    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate();
    const [presentation, setPresentation] = useState("");


    // Initialize a markdown parser
    const mdParser = new MarkdownIt(/* Markdown-it options */);

    function handleEditorChange({ html, text }) {
        console.log('handleEditorChange', html, text);
        // console.log(text)
        setPresentation(text)
    }

    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Portail Web", secondLevelLink: "/portail-web", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("webgate", dispatch)
    }, [])

    const [processOngoing, setProcessOngoing] = useState(false)
    const [displayLoader, setDisplayLoader] = useState(true);

    useEffect(() => {
        loadPresentaion();
    }, []);

    const loadPresentaion = async () => {
        const data_response = await getPresentation(states.userToken.access_token);
        if (data_response.response && data_response.response.status !== 200) {
            console.log(data_response.response?.data)
        } else {
            console.log("ok", data_response.data)
            setDisplayLoader(false)
            setPresentation(data_response.data?.description)
        }
    }


    const handleAddPresentation = async () => {
        setProcessOngoing(true)
        console.log(presentation)
        const add_presentaion_request = await addPresentation(presentation, states.userToken.access_token)
        console.log(add_presentaion_request)

        if (add_presentaion_request.status === 200) {
            console.log(add_presentaion_request)
            setProcessOngoing(false)
            toast.success(`Présentation configurée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });

        } else {
            setProcessOngoing(false)
            console.log(add_presentaion_request.response)
            let errorMsg = add_presentaion_request.response?.data?.error['description'][0]
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }


    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <h4 className="mb-3 text-left">Configuration Portail Web</h4>
                        {displayLoader == false ?
                            <div className="widget widget-content widget-content-area p-3 mb-3">
                                <h5 className='text-left'>Présentation</h5>
                                <hr />
                              
                                <MdEditor style={{ height: '500px' }}
                                          value={presentation}
                                          renderHTML={text => mdParser.render(text)} 
                                          canView={ {menu: true, md: true, html: true, fullScreen: false, hideMenu: false} }
                                          onChange={handleEditorChange} />

                                <hr />

                                <div className='text-right'>

                                    {
                                        processOngoing == false ? <button style={{ height: 45 }} className="btn btn-dark col-sm-2 mx-1" onClick={() => handleAddPresentation()}>Configurer</button>
                                            : <ProcessSpinner />}
                                </div>


                            </div> : <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>
                        }
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Webgate